var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"energy-ring"},[_c('title-one',{staticClass:"m-top",attrs:{"title":_vm.title || '',"ps-txt":_vm.psTxt}}),_c('div',{staticClass:"rank-three left"},[_c('mul-ring',{attrs:{"energy-consumption-data":_vm.energyConsumptionData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }